import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page84() {
  useEffect(() => {
    document.title = "Маяк — Страница 83"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page82" />
        <ForwardLink href="/page84" />
      </div>

      <p style={{ textAlign: "right" }}>83.</p>
      <p>
        МОЛОДОЙ возится, чтобы схватить его и поднести к тусклому<br/>
        свету из окна.
      </p>
      <p>Он начинает листать страницы...</p>
      <p>
        Здесь прекрасные воспоминания о прошлом старика, газетные<br/>
        вырезки, тинтайпы...
      </p>
      <p>
        МОЛОДОЙ находит пряди детских волос старика... нежно прикасается<br/>
        к ним...
      </p>
      <p>Затем...</p>
      <p>ОН НАХОДИТ ЗАПИСИ ЖУРНАЛА... (КАМЕРА не видит записи.)</p>
      <p>
        МОЛОДОЙ почти захлопывает его. Но не делает этого. Он продолжает<br/>
        читать...
      </p>
      <p>
        МОЛОДОЙ опускает лицо. Кажется, что тиканье ЧАСОВ становится громче<br/>
        с каждой секундой.
      </p>
      <p>МОЛОДОЙ выглядит как призрак.</p>
      <p>ОН РАЗБИВАЕТ ЧАСЫ СВОИМ КУЛАКОМ. Больше никакого тиканья.</p>
      <p>Осколки и кровь.</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – НЕСКОЛЬКО МГНОВЕНИЙ СПУСТЯ</p>
      <p>
        СТАРИК сидит на куче мусора. На нем только потный,<br/>
        мешковатый, профсоюзный костюм, жилетка с цепочкой<br/>
        для часов и кепка.
      </p>
      <p>Он курит ТРУБКУ...</p>
      <p>Она гаснет.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Проклятие.
      </p>
      <p>Он пытается найти спичку в этом хаосе.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        (самому себе)<br/>
        Огненная яма! Неужели в этом мире<br/>
        не осталось справедливости?
      </p>
      <p>Он роется в мусоре, разбрасывая его вокруг...</p>
      <p>Внезапно раздается звук чирканья СПИЧКИ (ЗА КАДРОМ)!</p>
      <p>СТАРИК поворачивается, испуганный.</p>
      <p style={{ textAlign: "right" }}>83.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page82" />
        <ForwardLink href="/page84" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710717369/the-lighthouse-script/jzppilbyzb13ezl6rt9s.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page84;
